<template>
<main>
  <Banner  img="images/kanapen.jpg"/>    
  <Content>
    <h1>the project</h1>
    <!-- <section> -->
    <p>
      <!-- <span style="font-family: Averia;">cityphography</span> is a blend of typography and street photography. -->
      <!-- <b>cityphograhpy</b> is a blend of typography and street photography.  -->
      cityphograhpy is a blend of typography and street photography.
      <br>
      A love project that first sparked in 2013 on a pier in Chicago, but really manifested only when there was "too much" free time during corona in Budapest.
      <br>
      <br>
      The idea was to make it stand out in some way from all the other similar projects out there, but mostly just to have a lot of fun making it.
      <br>
      <br>
      And now here it is, after many months in the making and tweaking, countless of happy hours spent shooting and coding. 
      Reached a shape that worth sharing.       
      Hope you'll enjoy, getting lost on the map just as I love getting lost in the city. 
      <br>
      Maybe one day a cityphography piece will hang on your wall too!
      <br>
      <br>
      I'm also pledging to donate <strike>10% of any profits to charities.</strike> 100% of any profits to help refugees of Ukraine, until revocation. Fuck War! Peace ☮
    </p>
    <!-- </section> -->

    <br>
    <section>
      <p>
        <b>beta info:</b> the site is currently in beta, so might have (most likely has) a few glitches and UX hiccups. 
        If you find anything broken, or just something minor but annoying, it would be epic if you can share it, and sorry for any inconvenience.
      </p>
    </section>

    <h1>the artist</h1>
    <p>
      Transylvanian born, Budapest based. A keen traveller, techno and bass lover, peaceful and hippie hearted. Trying to be less wrong. 
      Software architect and consultant by profession, seeing the beauty in this world with an engineer's eye.
      <br>
      <br>
      A flâneur strolling the streets, exploring life and himself, capturing moods and moments otherwise not explicable, not even with a thousand words.
    </p>

    <section>      
      <h1 id="faq">f.a.q. / info</h1>

      <h3>What is this whole thing?</h3>
      <p>
        An interactive collection of photos that look like letters. Like a font made of photographs. 
        Primarily an art project, but thought it would be cool if someone wants to hang it on the wall, so made it possible to order.
      </p>

      <h3>What does the beta mean?</h3>
      <p>
        An indication that the site is still making it's first baby steps. 
        And while it should not have any major broken part, but might have a few glitches and UX hiccups, plus it still has some limitations, like delivery is currently only available in Hungary, and lacks features like support for typing numbers.
      </p>

      <h3>Donation to charities</h3>
      <p>
        <b>UPDATE:</b> 100% of profits are donated to help refugees of Ukraine. Fuck War! Peace ☮
        <br>
        <br>
        <span style="opacity: 0.3; text-decoration:line-through;">If there will be any profits made (fingers crossed), 10% will be donated to charities in some form.
        
        Since the project just launched end of 2021 and is still very fresh, I don't know whether it will be an art related charity like hART, or food or something else. 
        Neither is it clear in what form would be the most helpful (cash or goods).
        <br>
        But I really hope that soon this question will become reality, and will be happy to share if we get there!</span>
      </p>

      <h3>Shipping</h3>
      <p>
        Currently delivery is only available in Hungary for 9.9 € incl. VAT, or free local pickup in Budapest (Dob street). 
        If you choose pickup, we'll get in touch to arrange the day and time, as there is no permanent physical pickup point.
        <br>
        The plan is to find a feasible way to ship to anywhere in the EU, but since selling is not the main goal of this project, I cannot give an exact date when this will be available.        
      </p>

      <h3>Payment options</h3>
      <p>
        Card payments are handled through integration with Stripe as the payment provider, and where available, Google and Apple Pay is also supported.
      </p>

      <h3>Ordering process, times</h3>
      <p>
        Once you configured your piece (min 3 max 12 letters due to physical limitations), add it and go to the cart, choose the delivery method, and click Checkout. If needed, delivery address will be collected during the checkout. 
        After the payment succeeds you will get a confirmation email. Both the printing and framing happens in different shops by professionals, and can take up to 1-2 weeks.
        <br>
        Once your piece is ready, you will either be notified in email that you can pick it up, or you will receive the tracking information from the shipping company once your piece is packaged carefully and handed over to them.
      </p>

      <h3>Return policy</h3>
      <p>
        Due to the nature of the "product", since each piece is custom made, there is no option to return and refund.
      </p>

      <h3>Size in real life</h3>
      <p>
        The visible area of each photograph is 10x15cm from the front, with 1cm space between them (the actual physical width is a bit bigger of course to be able to fit properly behind the mat). 
        The padding between the photos and the frame is 4cm, and the frame is 2cm thick. Total weight is around 1-3kg, depending on the number of your letters.
        <br>
        A few more frame types (classic, wide, metal) and colors are coming soon.
        <!-- for the Classic and Modern frames, and 7cm for the Wide and Metal frames. -->
      </p>

      <h3>Quality</h3>
      <p>
        Each photo is Giclée printed in the best fine art print manufacture in Budapest (they have Digigraphie certification, work with museums, major art galleries and exhibitions), with Epson SureColor P-Series professional photographic printers, on delicate mediaJET<sup>®</sup> PhotoArt White Satin fine art paper (made according to the DIN6738/ISO9706 norms for archival paper).
        <br>
        The frame is custom made of high quality wood by a professional local framing shop, it is glazed with 2mm real glass, and has acid-free mat between the artwork and the glass. Comes with integrated hangers.
      </p>

      <h3>Can I get just the photos?</h3>
      <p>
        A frameless option is in the making, but currently this is not available online. 
        If you would like to get it outside current delivery options, or for anything custom, get in touch and we will figure out something.
      </p>

      <br>
      <br>
      <br>
      <br>
      <h3>Didn't find the answer you were looking for, or have an idea?</h3>
      <p>
        Please get in touch on the <router-link :to="{path: '/contact'}">contact</router-link> page or drop a message on <a href="https://www.instagram.com/cityphography" target="_blank">instagram</a>. 
        <br>
        Be it a question about missing info, an awesome idea or collaboration, happy to hear from you!
      </p>

    </section>
  </Content>
</main>
</template>

<script>

import Content from '@/components/Content.vue';
import OverlayScrollbars from 'overlayscrollbars';
import Banner from '@/components/Banner.vue';

export default {
  name: 'About' ,
  components: {
    Content,
    Banner
  },
  metaInfo: {
      title: "about - cityphography",
      meta: [        
        { vmid: "og:title", property: "og:title", content: "about - cityphography" },
        { vmid: "description", name: "description", content: "About the cityphography art project, the artist behind it, and all product plus shipping information in the FAQ section." },
        { vmid: "og:description", property: "og:description", content: "About the cityphography art project, the artist behind it, and all product plus shipping information in the FAQ section." },                                
        { vmid: "og:image", property: "og:image", content: "https://cityphography.com/ogabout.jpg" }   // will only have any effect with prerendering for scrapers : )                             
      ],    
  },
  mounted: function(){
    //console.log(this.$router.currentRoute);
    // hack because the router cannot handle anchors, despite scoll behavior
    if(this.$router.currentRoute.hash == "#faq"){
      
      if(OverlayScrollbars(document.body))     
        setTimeout(() =>
          OverlayScrollbars(document.body).scroll({ el : document.getElementById('faq'), block : { y : "ifneeded", x : "nearest" }, margin : 50 }, 500)
        ,100);
      else
        document.getElementById('faq').scrollIntoView({ behavior: 'smooth' }); // fallback to native
    }
  }
}
</script>